import { ChemicalComponent } from "@/services/chemical-component"
import { Button, Col, Form, Input, InputNumber, Row, Space } from "antd"
import { useEffect } from "react"


export const PengRobinsonForm = (props: {
  component?: ChemicalComponent.Modal,
  onSave: (val) => void
  onCancel?: Function
}) => {
  const {onSave, onCancel, component}= props
  const [form] = Form.useForm()

  useEffect(() => {
    if (component) {
      form.setFieldsValue(component.prTwu)
    }
  }, [component, form])
  
  return <Form
    form={form}
    onFinish={(values) => {
      onSave({prTwu: values})
    }}
    className="mt-4"
  >
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='c0'
          label='c0'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='c1'
          label='c1'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='c2'
          label='c2'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      </Col>
    </Row>

    <Row justify={'end'}>
      <Space>
        <Button htmlType="button" onClick={() => onCancel?.()}>Cancel</Button>
        <Button type="primary" htmlType="submit">Save</Button>
      </Space>
    </Row>
    
  </Form>
}